import { CloudCommand } from "../types.js";

export const getConversations: CloudCommand = {
    action: "CONVERSATION/GET",
    commandName: "conversation.getConversations",
    buildPayload: ({ params }) => params,
};
